import {useQuery} from 'react-query'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {BASE_URL} from '../../config'
import axios from 'axios'
import {IVoucherFilterType, IVoucherList} from './_model'
import {useEffect, useState} from 'react'
import {searchItems} from '../../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import TableContent from '../../../utils/components/table-content/TableContent'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import voucherListColumn from './voucherListColumn'
import SelectEntriesOptions from '../../../utils/components/table-content/SelectEntriesOptions'
import {perPageItemsOptions} from '../../../utils/components/table-content/TableContentHeader'

type VoucherListProps = {
  searchTerm: string
  filterValues: Partial<IVoucherFilterType>
}

const GET_VOUCHER_LIST_URL = `${BASE_URL}/api/protect/getAllVoucher`

const VoucherList = ({searchTerm, filterValues}: VoucherListProps) => {
  const {
    pagination: {page, size, totalElement},
    handlePageChange,
    updatePagination,
    handlePagePerItem,
  } = usePaginationCounts(1, 10)

  const [voucherList, setVoucherList] = useState<IVoucherList[]>([])

  const {data, isLoading, error} = useQuery({
    queryKey: ['voucherList', {page, size, filterValues}],
    queryFn: async () => {
      const response = await axios.get(GET_VOUCHER_LIST_URL, {
        params: {
          page,
          size,
          ...(filterValues.sdate ? {sdate: filterValues.sdate} : {}),
          ...(filterValues.edate ? {edate: filterValues.edate} : {}),
          ...(filterValues.userId ? {userId: filterValues.userId} : {}),
          ...(filterValues.voucherId ? {voucherId: filterValues.voucherId} : {}),
        },
      })

      const data = await response.data
      return {
        list: data.data,
        pagination: data.pagenationResponse,
      }
    },
    staleTime: 0,
    cacheTime: 0,
  })

  const handleSelect = (selectType: string, id: number) => {}

  useEffect(() => {
    if (data) {
      const keys: (keyof IVoucherList)[] = ['user_full_name', 'amount']
      const filtered = searchItems(data.list, searchTerm, keys)
      setVoucherList(filtered || [])
      updatePagination(data.pagination)
    }
  }, [data, searchTerm])

  return (
    <ListViewProvider data={voucherList} isLoading={isLoading}>
      <div className='mb-5 d-flex justify-content-end'>
        <SelectEntriesOptions
          options={perPageItemsOptions}
          handleSelect={handlePagePerItem}
          value={size.toString()}
        />
      </div>
      <TableContent
        isLoading={isLoading}
        tableData={voucherList}
        tableColumn={voucherListColumn(handleSelect)}
        error={error as Error}
      >
        {isLoading && !data ? (
          <div className='d-flex justify-content-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <TablePagination
            totalElement={totalElement}
            isLoading={isLoading}
            itemsPerPage={size}
            currentPage={page}
            handlePageChange={handlePageChange}
          />
        )}
      </TableContent>
    </ListViewProvider>
  )
}

export default VoucherList
